import React from 'react';

import {FullTextSearchResult} from "@stores/SearchStore";


export interface SearchContextProps {
    searchResult: FullTextSearchResult;
}
export const SearchContext = ({searchResult}: SearchContextProps) => {
    if (!searchResult.highlight) {
        return null;
    }
    return (
        <div className='ItemLine__search-context label-medium'
             dangerouslySetInnerHTML={{'__html': searchResult.highlight.content + '...'}}
        />

    )
}